import { fork } from 'redux-saga/effects'

import attachmentsSaga from './attachment/sagas'
import authSaga from './auth/sagas'
import commonSaga from './common/sagas'
import companyDocumentsSaga from './companyDocuments/sagas'
import controlsSaga from './controls/sagas'
import dashboardSaga from './dashboard/sagas'
import dokumentsSaga from './dokuments/sagas'
import expenseSaga from './expense/sagas'
import filtersSaga from './filters/sagas'
import incomeSaga from './income/sagas'
import messageToAccountantSaga from './messageToAccountant/sagas'
import onboardingSaga from './onboarding/sagas'
import onboardingDocumentsSaga from './onboardingDocuments/sagas'
import partnersSaga from './partners/sagas'
import paymentSaga from './payment/sagas'
import postItSaga from './postit/sagas'
import quarantineSaga from './quarantine/sagas'
import reportsSaga from './reports/sagas'
import taxSaga from './tax/sagas'
import taxationDetailsSaga from './taxationDetails/sagas'

function* rootSaga() {
  yield fork(attachmentsSaga)
  yield fork(authSaga)
  yield fork(onboardingDocumentsSaga)
  yield fork(commonSaga)
  yield fork(companyDocumentsSaga)
  yield fork(controlsSaga)
  yield fork(dashboardSaga)
  yield fork(dokumentsSaga)
  yield fork(expenseSaga)
  yield fork(incomeSaga)
  yield fork(messageToAccountantSaga)
  yield fork(onboardingSaga)
  yield fork(partnersSaga)
  yield fork(paymentSaga)
  yield fork(postItSaga)
  yield fork(quarantineSaga)
  yield fork(reportsSaga)
  yield fork(taxSaga)
  yield fork(taxationDetailsSaga)
  yield fork(filtersSaga)
}

export default rootSaga
